import { TextInputFormik } from '@strata/react-inputs';
import { useFormikContext } from 'formik';
import PropTypes from 'prop-types';
import { useEffect } from 'react';

import { UserType } from 'services/constants';
import { useSSODomains } from 'services/Http';

const SSO_PASSWORD_VALUE = 'Ab@1none';

/**
 * PasswordEntry component that conditionally shows password field based on SSO domain configuration
 * @param {string} userType - User type to filter SSO domains: 'supplier', 'prescriber', 'payer', 'lighthouse', 'compass'
 */
export const PasswordEntry = ({ userType }) => {
    const { values, setFieldValue } = useFormikContext();

    const ssoDomains = useSSODomains(userType);

    const { upn, password } = values;
    const isSSODomain = ssoDomains?.includes(upn?.split('@')?.[1]);
    useEffect(() => {
        void (async () => {
            if (isSSODomain && password !== SSO_PASSWORD_VALUE) {
                await setFieldValue('password', SSO_PASSWORD_VALUE);
            }
        })();
    }, [isSSODomain, password, setFieldValue]);

    return !isSSODomain ? <TextInputFormik label="Password" id="password" required /> : null;
};

PasswordEntry.propTypes = { userType: PropTypes.oneOf(Object.values(UserType)).isRequired };
